import { Navigate, Outlet } from 'react-router-dom';
import type { StoreRole } from '@/entities/user';
import { useStoreContext } from '@/shared/lib/store-context';
import { ROUTES } from '@/shared/config/routes';

/** Restricts a routed subtree to one role within the current store (must be inside `<StoreScope/>`). */
export function RequireStoreRole({ role }: { role: StoreRole }) {
  const ctx = useStoreContext();
  if (ctx.role !== role) return <Navigate to={ROUTES.stores} replace />;
  return <Outlet />;
}
